import Stream from './Stream.container';

export default Stream;



// WEBPACK FOOTER //
// ./src/ui/streams/children/stream/index.js